import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface ProductCardProps {
  name: string
  description: string
  image: string
  sizes: Array<{
    size: string
    price: string
  }>
}

export function ProductCard({ name, description, image, sizes }: ProductCardProps) {
  const { t } = useTranslation()
  const [selectedSize, setSelectedSize] = useState(0)

  return (
    <div className="product-card">
      <img src={image} alt={name} loading="lazy" />
      <span className="product-name">{name}</span>
      <div className="product-options">
        <p className="product-description">{description}</p>
        <div className="size-options">
          {sizes.map((size, index) => (
            <button
              key={index}
              className={`size-btn ${selectedSize === index ? 'active' : ''}`}
              onClick={() => setSelectedSize(index)}
            >
              {size.size}
            </button>
          ))}
        </div>
        <p className="pricing">{t('pricing.demand')}</p>
        <Link to="/contact#contact-form" className="btn product-cta">
          {t('cta.contact')}
        </Link>
      </div>
    </div>
  )
}